import styled from 'styled-components'

import { helpers, toRem } from 'styles'

export const PolicyScore = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	color: ${helpers.color.linkHighlight};
	margin: 12px 0 8px;
	font-size: ${toRem(18)};
	font-weight: 600;
`
